export enum History {
  byCurrency = 'history.byCurrency',
}
